<template>
  <div class="out_box">
    <div class="temp_t">
      <div class="temp_t_btn" @click="openDialog">新增套图</div>
      <div class="aiwork_headform">
        <el-date-picker
          v-model="searchForm.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-input v-model="searchForm.batch_number" style="width: 180px;" placeholder="批次"></el-input>
        <el-select v-model="searchForm.status" clearable placeholder="状态">
          <el-option label="未开始" :value="0"></el-option>
          <el-option label="进行中" :value="1"></el-option>
          <el-option label="已完成" :value="2"></el-option>
          <el-option label="已取消" :value="3"></el-option>
        </el-select>
        <el-select v-model="searchForm.user_id" v-if="userRole.key != 'employee'">
          <el-option
            v-for="item in subAccountList"
            :key="item.id"
            :label="`${item.nickname}${item.id == $store.state.userInfo.id ? '(我)' : ''}`"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button class="search_btn" @click="onSubmit">
          搜索 
        </el-button>
      <!-- <el-button class="search_btn" @click="resetsearchForm()">重置</el-button> -->
      </div>
    </div>
    <!-- <div class="temp_classi">
      <div v-for="(item, index) in categoryList" class="temp_classi_item" :class="{active: searchForm.group_id == item.id}" @click="changeCategory(item.id)">
        {{ item.name }} <span>{{ item.num }}</span>
      </div>
    </div> -->
    <el-table :data="tableData" class="main_table">
      <el-table-column prop="batch_number" label="批次">
        <template slot-scope="scope">
          <div class="exceedomit">{{ scope.row.remarks }}</div>
          <div>{{ scope.row.batch_number }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="任务数量">
        <template slot-scope="scope">
          任务数量：{{scope.row.num}}
          <el-divider direction="vertical"></el-divider>
          <span style="color: #3FBF72">完成数量：{{successNum(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="任务进度">
        <template slot-scope="scope">
          <el-progress :percentage="scope.row.num?Number(((successNum(scope.row)/scope.row.num)*100).toFixed(0)):0" :color="percentColors"></el-progress>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ scope.row.status==0?'未开始':scope.row.status==1?'进行中':scope.row.status==2?'已完成':scope.row.status==3?'已取消':'未知' }}
        </template>
      </el-table-column>
      <el-table-column prop="user.nickname" label="用户" />
      <el-table-column prop="create_time" label="创建时间" />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="checkDetail(scope.row.id)">查看详情</el-button>
          <el-button slot="reference" type="text" v-if="userInfo.id == scope.row.user.id" @click="toRemark(scope.row)">备注</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="main_pagination"
      background
      layout="prev, pager, next"
      :total="total"
      @current-change="setPage"
      :current-page.sync="searchForm.page"
      :page-size="searchForm.limit"
    >
    </el-pagination>
    <el-dialog class="main_dialog"
      title="新增套图"
      :visible.sync="dialogShopVisible"
      width="20%">
        <el-select
          v-model="selectShopId"
          placeholder="请选择店铺">
          <el-option
            v-for="item in shopList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      <div style="text-align: right;margin-top: 24px;">
        <el-button class="dialog_confirm" size="small" @click="selectShopConfirm">确 定</el-button>
        <el-button class="dialog_cancel" size="small" @click="dialogShopVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-drawer
      class="main_drawer"
      size="50%"
      :visible.sync="addDrawer"
      direction="rtl"
      :withHeader="false"
      :wrapperClosable="false"
    >
      <div class="main_drawer_body">
        <div class="select_box">
          <div
            class="select_item"
            :class="{ active: currentAdd == 'temp' }"
            @click="currentAdd = 'temp'"
          >
            <svg-icon icon-class="selectTemp" />
            <!-- 选择模板 -->
          </div>
          <div class="select_line"></div>
          <!-- v-show="print_names.length!=0" -->
          <div
            class="select_item"
            :class="{ active: currentAdd == 'print' }"
            @click="multipleSelection.length!=0 ? currentAdd = 'print' : ''"
          >
            <svg-icon icon-class="selectPrint" />
            <!-- 印花选择 -->
          </div>
        </div>
        <div v-show="currentAdd == 'temp'">
          <el-tabs
            v-model="searchTemp.type"
            @tab-click="handleClick"
            class="temp_tabs"
          >
            <el-tab-pane label="单印花模板" name="1"></el-tab-pane>
            <el-tab-pane label="多印花模板" name="2"></el-tab-pane>
          </el-tabs>
          <el-tabs
            v-model="searchTemp.category_id"
            @tab-click="handleClick"
            class="classify_tabs"
          >
            <el-tab-pane
              :label="item.name"
              :name="item.id + ''"
              v-for="item in classifyList"
            ></el-tab-pane>
          </el-tabs>

          <el-table
            :data="tempTableData"
            @selection-change="handleSelectionChange"
            class="main_d_table"
          >
            <el-table-column
              type="selection"
              :selectable="checkSelectable"
              width="55"
            />
            <el-table-column prop="date" label="素材">
              <template slot-scope="scope">
                <div class="table_sucai">
                  <img :src="scope.row.images[0].image_url" alt="" />
                  <div>
                    <div class="table_sucai_title">
                      {{ scope.row.name }}
                      <span>{{
                        scope.row.type == 1 ? "单印花" : "多印花"
                      }}</span>
                    </div>
                    <div class="table_sucai_item">
                      印刷大小：
                      <div style="width: 200px; display: flex; flex-wrap: wrap">
                        <div v-for="size in scope.row.sizes">
                          <div
                            style="margin-right: 4px"
                            v-for="cutpiece in size.cutpieces"
                          >
                            {{ size.size }}-{{ cutpiece.name }}:{{
                              cutpiece.width
                            }}*{{ cutpiece.height }}cm
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="table_sucai_item">
                      尺码规格：
                      <p v-for="size in scope.row.sizes">{{ size.size }}</p>
                    </div>
                    <div class="table_sucai_item">
                      颜色规格：<span
                        v-for="color in scope.row.colors"
                        :style="{ background: color.hex_value }"
                      ></span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="轮播图">
              <template slot-scope="scope">
                <div class="table_banner">
                  <img
                    v-for="item in scope.row.images"
                    :src="item.image_url"
                    alt=""
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="currentAdd == 'print'">
          <div style="margin-top: 24px;" class="drawer_cascader">
            素材分类：
            <el-cascader
              v-model="materialForm.parent_id"
              placeholder="请选择素材分类"
              :options="folderTree"
              @change="getMaterialList"
              @expand-change="elCascaderOnClick"
              :props="{ checkStrictly: true, emitPath: false, label: 'name', value: 'id' }"
              clearable
            ></el-cascader>
            <el-upload
              action
              accept=".jpg, .png"
              ref="upload"
              multiple
              :limit="200"
              :show-file-list="false"
              :http-request="handleUploadImg">
              <el-button class="drawer_upbtn">上传图片</el-button>
            </el-upload>
            <el-button class="drawer_upbtn" @click="addAllImage">选择全部</el-button>
          </div>
          <div class="print_list">
            <div
              v-for="item in libraryTableData"
              class="print_item"
              :class="{ active: showCheckFn(item.id) }"
            >
              <div v-for="(group, gidx) in select_group" class="print_group" v-if="group.includes(item.url)">
                {{ gidx + 1 }}-{{ print_names[group.indexOf(item.url)] }}
              </div>
              <img :src="item.thumb" @click="addImg(item)" />
            </div>
          </div>
          <div class="print_tips">
            <div class="print_tips_l">
              选择印花预览
              <div v-if="print_names.length > 1">
                <el-button class="print_batchbtn" :class="{active: batchtype == index}" size="small" v-for="(item,index) in print_names" @click="handleBatchSelect(index)">
                  批量{{item}}
                </el-button>
              </div>
            </div>
            <i :class="showGroupSwiper ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="showGroupSwiper = !showGroupSwiper"></i>
          </div>
            <swiper :options="swiperOption" ref="swiperRef" class="print_s_box" v-show="showGroupSwiper">
              <swiper-slide v-if="select_group.length == 0" class="print_s_item">
                <div class="print_s_inner">
                  <div class="print_s_type" v-for="name in print_names">
                    <div class="print_s_img">
                      <p></p>
                    </div>
                    {{ name }}
                  </div>
                </div>
                <div>印花1</div>
              </swiper-slide>
              <swiper-slide
                v-else
                v-for="(group, index) in select_group"
                :key="index"
                class="print_s_item"
              >
                <div class="print_s_inner">
                  <div class="print_s_type" v-for="(name, i) in print_names">
                    <div class="print_s_img">
                      <div class="print_s_del" @click="handleBtmprintDel(index, i)">
                        <i class="el-icon-delete"></i>
                      </div>
                      <img v-if="group[i] != ''" :src="group[i]" />
                      <p v-else></p>
                    </div>
                    {{ name }}
                  </div>
                </div>
                <div>印花{{ index + 1 }}</div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>
      </div>
      <div class="main_drawer_footer">
        <el-button
          :disabled="multipleSelection.length==0"
          class="drawer_confirm" 
          @click="currentAdd == 'temp' ? currentAdd = 'print' : currentAdd = 'temp';batchtype = 99;isBatchSelecting=false">
          {{currentAdd == 'temp' ? '下一步' : '上一步'}}
        </el-button>
        <el-button
          v-show="currentAdd == 'print'"
          class="drawer_confirm"
          @click="handleSubmitForm"
          :loading="loading"
          :disabled="multipleSelection.length==0 || select_img_ids.length==0"
          >
          {{ loading ? "提交中 ..." : "立 即 生 成" }}
          <span class="expend_num" v-if="beanNum">(消耗{{beanNum}}积分)</span>
          </el-button>
        <el-button class="drawer_cancel" @click="addDrawer = false"
          >取 消</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { categoryGetList, templateGetList } from "@/api/template";
import { templateTaskGetList,templateTaskCreate, templateTaskGetCategList, templateTaskRemark } from "@/api/templateTask";
import { materialGetList, folderGetTree } from "@/api/material";
import { shopGetList } from '@/api/shop'
import { folderFileUpload } from "@/api/material";
import { allSubGetList } from '@/api/subaccount'
import { aiGetBeansConfig } from '@/api/imgAndText'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "setPicture",
  components: {Swiper, SwiperSlide},
  data() {
    return {
      categoryList: [{ name: "全部", id: 0 }],
      total: 0,
      searchTemp: {
        type: "1",
        category_id: "",
        page: 1,
        limit: 10000000,
      },
      subAccountList: [{id: -1, nickname: '全部'}],
      searchForm: {
        page:1,
        limit:10,
        date: [],
        status: "",
        batch_number:'',
      },
      materialForm: {
        parent_id: 0,
        page: 1,
        limit: 10000000,
      },
      tableData: [],
      percentColors: [
        { color: "#FF5733", percentage: 50 },
        { color: "#A5D63F", percentage: 75 },
        { color: "#3FBF72", percentage: 100 },
      ],
      select_imgs: [],
      select_img_ids: [],
      isBatchSelecting: false,
      batchtype: 99,
      print_names: [],
      addDrawer: false,
      currentAdd: "temp",
      loading: false,
      classifyList: [{ name: "全部", id: "" }],
      tempTableData: [],
      libraryTableData: [],
      folderTree: [
        {
          id: 0,
          name: "全部",
          type: 1,
          children: [],
        },
      ],
      multipleSelection: [],

      showGroupSwiper: true,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween : '2%',
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next"
        },
        slidesPerGroup: 3,
      },

      dialogShopVisible: false,
      selectShopId: '',
      shopList: [],

      beansConfig: null,
    };
  },
  created() {
    if(this.userRole.key != 'employee') {
      this.$set(this.searchForm, 'user_id', -1)
    }
    this.getSubList()
    templateTaskGetCategList().then(res => {
      this.categoryList = this.categoryList.concat(res.data.data)
    })
    this.templateTaskGetList();
    this.getCategoryList();
    this.getMaterialList();
    this.getFolderTree();
  },
  computed: {
    select_group: function () {
      let groupList = [];
      const chunkSize = this.print_names.length;
      for (let i = 0; i < this.select_imgs.length; i += chunkSize) {
        const chunk = this.select_imgs.slice(i, i + chunkSize);
        while (chunk.length < chunkSize) {
          chunk.push("");
        }
        groupList.push(chunk);
      }
      return groupList;
    },
    select_ids: function () {
      let groupList = [];
      const chunkSize = this.print_names.length;
      for (let i = 0; i < this.select_img_ids.length; i += chunkSize) {
        const chunk = this.select_img_ids.slice(i, i + chunkSize);
        groupList.push(chunk);
      }
      return groupList;
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    userRole() {
      return this.$store.getters.userRole
    },
    beanNum() {
      let initial = this.beansConfig?.beans
      let iscoutimg = this.beansConfig?.per_image
      if(iscoutimg) {
        let imglen = this.select_group.length
        initial = imglen * initial
      }

      return initial || 0
    }
  },
  methods: {
    handleBatchSelect(index) {
      this.batchtype = this.batchtype == index ? 99 : index
      this.isBatchSelecting = this.batchtype == index
    },
    // 级联选择器点击文字也可选中
    elCascaderOnClick() {
      setTimeout(() => {
        document.querySelectorAll('.el-cascader-node__label').forEach((el) => {
          el.onclick = function () {
            this.previousElementSibling.click()
          }
        })
      }, 100)
    },
    handleUploadImg(param) {
      const isLt20M = Number(param.file.size / 1024 / 1024) < 20;
      if (!isLt20M) {
        this.$message.warning('图片过大，已自动压缩')
      }
      let formData = new FormData()
      formData.append('file', param.file)
      formData.append('folder_id', this.materialForm.parent_id);
      folderFileUpload(formData).then(res => {
        this.getMaterialList()
        // this.generateForm.image = res.data.url
        // this.libraryTableData.push({id: res.data.id, thumb: res.data.url})

      })
    },
    successNum(detailData){
      let success_num = 0;
      detailData.materialGroups.forEach((materialG) => {
        let is_success=true;
        detailData.images.forEach((img) => {
          console.log()
          if (img.group_id==materialG.id && img.status != 2) {
            is_success = false;
          }
        });
        if(is_success){
          success_num++;
        }
      });
      return success_num;
    },
    checkDetail(id){
      this.$router.push({
        path: "/toolbox/setPicture/detail",
        query: {
          id: id,
        },
      });
    },
    toRemark(row) {
      var _this = this;
      let remarkContent = row.remarks || '';
      this.$prompt('', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        inputPlaceholder: '请输入备注',
        inputType: 'textarea',
        inputValue: remarkContent,
        inputAttributes: { rows: 5 }
      }).then(({ value }) => {
        templateTaskRemark(row.id, {type: 'template_task', task_id: row.id, remarks: value}).then(res => {
          _this.$message.success('备注成功');
          _this.templateTaskGetList()
        })
      }).catch(() => {
      });
    },
    setPage(v){
      this.searchForm.page=v;
      this.templateTaskGetList();
    },
    checkSelectable(row, index) {
      if (this.multipleSelection.length == 0) {
        return true;
      } else {
        return row.print_names == JSON.stringify(this.print_names);
      }
    },
    handleSelectionChange(val) {
      this.select_imgs=[];
      this.select_img_ids=[];
      this.print_names = [];
      val.forEach((row) => {
        this.print_names = JSON.parse(row.print_names);
      });
      this.multipleSelection = [];
      this.multipleSelection = val.map((item) => {
        return item.id;
      });
    },
    showCheckFn(id) {
      if (this.select_img_ids.indexOf(id) == -1) {
        return false;
      } else {
        return true;
      }
    },
    handleBtmprintDel(index, indey) {
      let curIdx = index * this.print_names.length + indey
      if(this.print_names.length == 1) {
        this.select_imgs.splice(curIdx, 1)
        this.select_img_ids.splice(curIdx, 1)
      }else {
        this.$set(this.select_imgs, curIdx, '')
        this.$set(this.select_img_ids, curIdx, '')
      }
    },
    addAllImage() {
      // 已选择的图片id做个集合，用来查找是否存在，性能比indexOf好
      const selectedIdsSet = new Set(this.select_img_ids.filter(id => id !== ''));
      this.libraryTableData.forEach(item => {
        // let a = this.select_img_ids.indexOf(item.id);
        if(!selectedIdsSet.has(item.id)) {
          if(this.isBatchSelecting) {
            const step = this.print_names.length
            let assigned = false
            for (let i = this.batchtype; i < this.select_img_ids.length; i += step) {
              if (this.select_img_ids[i] === '') {
                this.$set(this.select_img_ids, i, item.id)
                this.$set(this.select_imgs, i, item.url)
                selectedIdsSet.add(item.id);
                assigned = true;
                break;
              }
            }
            if (!assigned) {
              const nextIndex = this.batchtype + Math.ceil((this.select_img_ids.length - this.batchtype) / step) * step;
              while(this.select_img_ids.length < nextIndex) {
                this.select_img_ids.push('');
                this.select_imgs.push('');
              }
              this.$set(this.select_img_ids, nextIndex, item.id)
              this.$set(this.select_imgs, nextIndex, item.url)
              selectedIdsSet.add(item.id);
            }

          }else {
            let index = this.select_img_ids.indexOf('');
            if (index !== -1) {
              this.$set(this.select_img_ids, index, item.id)
              this.$set(this.select_imgs, index, item.url)
              selectedIdsSet.add(item.id);
            } else {
              this.select_img_ids.push(item.id);
              this.select_imgs.push(item.url);
              selectedIdsSet.add(item.id);
            }
          }
        }
      })
    },
    addImg(item) {
      let a = this.select_img_ids.indexOf(item.id);
      if(a != -1) {
        this.$set(this.select_img_ids, a, '')
        this.$set(this.select_imgs, a, '')
        return;
      }

      if(this.isBatchSelecting) {
        const step = this.print_names.length
        let assigned = false
        // 找到对应印花位置是否有空位，有了就跳出
        for (let i = this.batchtype; i < this.select_img_ids.length; i += step) {
          if (this.select_img_ids[i] === '') {
            this.$set(this.select_img_ids, i, item.id)
            this.$set(this.select_imgs, i, item.url)
            assigned = true;
            break;
          }
        }
        // 没有空位
        if (!assigned) {
          // Math.ceil((this.select_img_ids.length - this.batchtype) / step) 表示现在已经有多少完整的组
          // * step 再 + this.batchtype 获取到下一组对应印花位置的索引
          const nextIndex = this.batchtype + Math.ceil((this.select_img_ids.length - this.batchtype) / step) * step;
          // 如果数组长度不足就补足到nextIndex
          while(this.select_img_ids.length < nextIndex) {
            this.select_img_ids.push('');
            this.select_imgs.push('');
          }
          this.$set(this.select_img_ids, nextIndex, item.id)
          this.$set(this.select_imgs, nextIndex, item.url)
        }
      }else {
        let index = this.select_img_ids.indexOf('');
        if (index !== -1) {
          this.$set(this.select_img_ids, index, item.id)
          this.$set(this.select_imgs, index, item.url)
        } else {
          this.select_img_ids.push(item.id);
          this.select_imgs.push(item.url);
        }
      }
    },
    getMaterialList() {
      materialGetList(this.materialForm).then((res) => {
        if (res.code == 200) {
          this.libraryTableData = [];
          res.data.data.forEach((element) => {
            if (element.type == 2) {
              this.libraryTableData.push(element);
            }
          });
        }
      });
    },
    getFolderTree() {
      folderGetTree().then((res) => {
        this.folderTree[0].children = res.data;
      });
    },
    resetsearchForm() {
      this.searchForm = {
        page:1,
        limit:10,
        date: [],
        status: "",
        batch_number:'',
      };
      this.templateTaskGetList();
    },
    templateTaskGetList(){
      let searchForm = JSON.parse(JSON.stringify(this.searchForm));
      if (this.searchForm.date.length == 2) {
        searchForm.date = '';
        searchForm.start_time = this.searchForm.date[0];
        searchForm.end_time = this.searchForm.date[1];
      }
      templateTaskGetList(searchForm).then(res=>{
        if(res.code==200){
          this.tableData = res.data.data;
          this.total = res.data.total;
        }
        this.messageBox(res);
      });
    },
    onSubmit() {
      this.templateTaskGetList();
    },
    handleClick() {
      this.getTemplateList();
    },
    openDialog() {
      this.selectShopId = ''
      this.getShopList()
      this.dialogShopVisible = true
      aiGetBeansConfig('template_task').then(res => {
        this.beansConfig = res.data
      })
    },
    selectShopConfirm() {
      this.currentAdd = "temp";
      this.addDrawer = true;
      this.getTemplateList();
      this.dialogShopVisible = false
    },
    handleSubmitForm() {
      let data={
        source: 'file',
        shop_id: this.selectShopId,
        template_ids:this.multipleSelection,
        file_ids:this.select_ids,
      }
      this.loading=true;
      templateTaskCreate(data).then(res=>{
        this.$store.dispatch("USER_INFO");
        if(res.code==200){
          this.addDrawer = false;
          this.searchForm.page=1;
          this.templateTaskGetList();
        }
        this.loading=false;
        this.messageBox(res);
      }).catch(error=>{
        this.loading=false;
        this.$message.error('接口错误,请重试.');
      })
    },
    getShopList() {
      shopGetList({page: 1, limit: 500, status: 1}).then(res => {
        this.shopList = res.data.data
      })
    },
    getCategoryList() {
      categoryGetList({ page: 1, limit: 500 }).then((res) => {
        this.classifyList = this.classifyList.concat(res.data);
      });
    },
    getTemplateList() {
      let searchTemp = JSON.parse(JSON.stringify(this.searchTemp));
      if (this.searchTemp.category_id == 0) {
        searchTemp.category_id = "";
      }
      templateGetList(searchTemp).then((res) => {
        if (res.code == 200) {
          this.select_imgs=[];
          this.select_img_ids=[];
          this.print_names = [];
          this.multipleSelection = [];
          this.tempTableData = res.data.data;
        }
      });
    },
    getSubList() {
      allSubGetList().then(res => {
        this.subAccountList = this.subAccountList.concat(res.data)
      })
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .main_table th.el-table__cell.el-table-column--selection .el-checkbox__inner {
    display: none !important;
  }
.out_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .temp_t {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .temp_t_btn {
      border-radius: 8px;
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      font-size: 20px;
      font-weight: 500;
      color: #F7F8FA;
      width: 171px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
    }
  }
  .temp_classi {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-top: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #EDEDED;
    .temp_classi_item {
      font-size: 16px;
      margin-left: 24px;
      // color: #EDEDED;
      cursor: pointer;
      span {
        font-size: 14px;
        // color: #CCCCCC;
      }
      &.active {
        // color: #FFFFFF;
        font-weight: 600;
      }
    }
    .temp_classi_add {
      padding: 5px 18px;
      border-radius: 24px;
      font-size: 12px;
      margin-left: 24px;
      border: 1px solid #BFBFBF;
      cursor: pointer;
    }
  }
  .select_box {
    display: flex;
    align-items: center;
    .select_item {
      // font-size: 12px;
      color: #B3B3B3;
      cursor: pointer;
      .svg-icon {
        width: 80px;
        height: 24.89px;
        vertical-align: -0.5em;
      }
      &::before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-right: 12px;
        background: #e0e0e0;
        border-radius: 50%;
        margin-bottom: 2px;
      }
      &.active {
        color: #acaf0b;
        // font-size: 39px;
        .svg-icon {
          width: 88px;
          height: 37.34px;
        }
        &::before {
          width: 8px;
          height: 8px;
          background: #acaf0b;
          margin-bottom: 6px;
        }
      }
    }
    .select_line {
      border: 1px solid #e5e5e5;
      width: 28px;
      height: 0px;
      margin: 0 16px;
    }
  }
  .temp_tabs {
    margin-top: 24px;
    /deep/ .el-tabs__header {
      margin: 0 0 24px;
      .el-tabs__nav-wrap {
        &::after {
          background: #737373;
          height: 1px;
        }
        .el-tabs__active-bar {
          background: #acaf0b;
        }
        .el-tabs__item {
          color: #737373;
          font-size: 12px;
          &.is-active {
            color: #acaf0b;
            font-size: 14px;
          }
          &:nth-child(2) {
            padding-left: 8px;
          }
        }
      }
    }
  }
  .classify_tabs {
    /deep/ .el-tabs__nav-wrap {
      &::after {
        display: none;
      }
      .el-tabs__active-bar {
        background: #acaf0b;
      }
      .el-tabs__item {
        color: #737373;
        font-size: 16px;
        &.is-active {
          color: #595959;
        }
        &:nth-child(2) {
          padding-left: 8px;
        }
      }
    }
  }
  .exceedomit {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .table_sucai {
    display: flex;
    width: max-content;
    img {
      max-width: 112px;
      max-height: 112px;
      margin-right: 16px;
      object-fit: cover;
      align-self: center;
    }
    .table_sucai_title {
      font-size: 16px;
      span {
        display: inline-block;
        font-size: 12px;
        border-radius: 18px;
        background: #3b4663;
        color: #ffffff;
        width: 56px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        margin-left: 8px;
      }
    }
    .table_sucai_item {
      display: flex;
      color: #737373;
      font-size: 12px;
      p {
        margin-right: 4px;
      }
      span {
        display: inline-block;
        align-self: center;
        width: 12px;
        height: 12px;
        margin-right: 4px;
        border: 1px solid #ededed;
      }
    }
  }
  .table_banner {
    width: 70%;
    img {
      width: 54px;
      height: 54px;
      margin-right: 4px;
      margin-bottom: 5px;
      object-fit: cover;
      vertical-align: middle;
    }
  }
  .drawer_cascader {
    display: flex;
    align-items: center;
    /deep/ .el-input__inner {
      border-radius: 8px;
      background: #FFFFFF;
      height: 48px;
      line-height: 48px;
      // border: 1px solid #525459;
      // color: #fff;
    }
    .drawer_upbtn {
      margin-left: 16px;
      color: #fff;
      background: linear-gradient(90deg, #4D95E8 0%, #2A82E4 100%);
      // border-radius: 25px;
      border: none;
    }
  }
  .print_list {
    margin-top: 24px;
    border-radius: 8px;
    // background: #151a29;
    border: 1px solid #bfbfbf;
    padding: 16px;
    height: 450px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 2.5%;
    &::-webkit-scrollbar {
      display: none;
    }
    .active {
      border: 1px solid #1d41ad !important;
    }
    .print_item {
      width: 14.5%;
      height: fit-content;
      position: relative;
      border: 1px solid #bfbfbf;
      .print_group {
        position: absolute;
        z-index: 1;
        top: 4px;
        left: 4px;
        border-radius: 4px;
        padding: 4px;
        font-size: 13px;
        background: #2A82E4;
        color: #fff;
      }
      &::after {
        content: "";
        padding-top: 100%;
        display: block;
      }
      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: contain;
      }
    }
  }
  .print_tips {
    color: #595959;
    font-size: 12px;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .print_tips_l {
      display: flex;
      align-items: center;
    }
    .print_batchbtn {
      background: #2A82E4;
      margin-left: 16px;
      color: #fff;
      border: none;
      &.active {
        color: #f5f5f5;
        background: #2277da;
        box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
      }
    }
    .el-icon-arrow-down, .el-icon-arrow-up {
      font-size: 16px;
      cursor: pointer;
    }
  }
  .print_s_box {
    --swiper-navigation-size: 32px;
    --swiper-navigation-color: #2A82E4;
    margin-top: 16px;
    // display: flex;
    // flex-wrap: wrap;
    // gap: 2%;
    position: relative;
    .print_s_item {
      text-align: center;
      font-size: 14px;
      margin-bottom: 16px;
      width: 32%;
      .print_s_inner {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        border: 1px dashed #bfbfbf;
        margin-bottom: 16px;
        .print_s_type {
          width: 114px;
          margin: 0 5px;
          .print_s_img {
            position: relative;
            border: 1px solid #bfbfbf;
            width: 100%;
            margin-bottom: 8px;
            .print_s_del {
              position: absolute;
              z-index: 2;
              right: 0;
              top: 0;
              width: 18px;
              height: 18px;
              text-align: center;
              line-height: 14px;
              font-size: 12px;
              color: #fff;
              border-radius: 0 0 0 4px;
              background: rgba(0, 0, 0, 0.6);
              cursor: pointer;
            }
            &::after {
              content: "";
              padding-top: 100%;
              display: block;
            }
            img {
              z-index: 1;
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              object-fit: contain;
            }
          }
        }
      }
    }
  }
}
</style>